// lbl.login.

export const login = {
    welcome_burgerking: "Welcome to Burgerking",
    phoneNo: {
        name: 'Mobile no.',
        placeholder: 'Mobile no.',
        required: '',
        too_short: '',
        invalid: '',
    },
    sign_in: 'Sign In',
    or: 'Or',
    don_t_have_an_account: 'Don’t have an account?',
    create_account: 'Create Account',
    continue_as: 'Continue as',
    guest: 'Guest',
    phoneNoRequire: {
        name: 'Mobile No. (Thai No. Only)',
        placeholder: 'Mobile No. (Thai No. Only)',
        required: 'Please enter mobile no.',
        too_short: 'Contact number must be 10 digits',
        invalid: '',
    },
    name: {
        name: 'Name',
        placeholder: 'Name',
        required: 'Please enter name',
        too_short: '',
        invalid: '',
    },
    read_accept: 'I have read and accept',
    term: 'terms & conditions',
    and: 'and',
    privacy: 'privacy policy',
    of_burgerking: 'of Burger King',

    i_agree: 'I agree to receive the information including other marketing activities from Burger King and',
    affiliated_companies: 'affiliated companies.',
    learn_more: 'We will keep your data confidential. Learn more about',
    privacy_policy: 'privacy policy',
    form_company: "from company's website.",

    i_interest: '',
    
    submit: 'Continue',

    confirm_guest: {
        look_like: 'Looks like you are an exiting customer',
        with: 'with this mobile number',
        what: "What'd you like to do",
        login: 'Login',
        continue_as_guest: 'Continue as guest'
    },

    please_setup_pin: 'Please setup PIN',
    enter_your_pin: 'Enter your PIN',

};
